<template>
  <layout-basic>


    <h3 class="title is-4">New test type</h3>

    <form action="">

      <section>
        <b-steps>

          <b-step-item step="1" label="General" :clickable="isStepsClickable">
            <test-type-general/>
          </b-step-item>

          <b-step-item step="2" label="Test method" :clickable="isStepsClickable">
            <test-type-method/>
          </b-step-item>


          <b-step-item step="3" label="Validator" :clickable="isStepsClickable">
            <test-type-validator/>
          </b-step-item>


          <b-step-item step="4" label="Alert" :clickable="isStepsClickable" disabled>
            <test-type-alert/>
          </b-step-item>
          <br>
          <br>
          <template
            slot="navigation"
            slot-scope="{previous, next}">
            <b-button
              outlined
              :disabled="previous.disabled"
              class="is-pulled-left"
              @click.prevent="previous.action">
              Previous

            </b-button>

            <b-button
              v-if="!next.disabled"
              outlined
              :disabled="next.disabled"
              class="is-pulled-right"
              @click.prevent="next.action">
              Next
            </b-button>

            <button v-if="next.disabled" class="button is-primary is-pulled-right" @click="formSubmit">Save</button>
          </template>
        </b-steps>
      </section>
      <br>
      <br>
      <br>
      <br>
    </form>
  </layout-basic>
</template>

<script>

import TestTypeGeneral from '@/components/TestType/Form/General'
import TestTypeMethod from '@/components/TestType/Form/TestMethod'
import TestTypeAlert from '@/components/TestType/Form/Alert'
import TestTypeValidator from '@/components/TestType/Form/Validator'
import TestTypeService from '@/services/TestTypeService'
import LayoutBasic from '@/layouts/LayoutBasic'


export default {
  name: 'NewTestType',

  components: {
    LayoutBasic,
    TestTypeGeneral,
    TestTypeMethod,
    TestTypeAlert,
    TestTypeValidator
  },

  data() {
    return {
      isStepsClickable:true
    }
  },

  created() {

  },

  methods: {
    formSubmit(e) {
      e.preventDefault()
      const requestData = this.$store.getters['testType/testTypeRequestData'];
      TestTypeService.new(requestData)
        .then(response => {
          this.$router.push({path: '/test-types'})
        })
    },
  }
}
</script>
